import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';

const NoDisposals = ({ t }) => (
  <section className="panel-wrapper text-center">
    <h2>{t('Nemáte žiadne pohľadávky')}</h2>
    <Row center="xs">
      <Col xs={12} sm={8}>
        <p style={{ marginBottom: 20 }}>
          {t(
            'Momentálne nemáte odkúpené žiadne pohľadávky. Pre ich odkúpenie kontaktujte Maják.'
          )}
        </p>
      </Col>
    </Row>
  </section>
);

NoDisposals.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(NoDisposals);



// WEBPACK FOOTER //
// ./src/features/disposals/components/NoDisposals.js